import { render, staticRenderFns } from "./AccountType.vue?vue&type=template&id=06823898"
import script from "./AccountType.vue?vue&type=script&lang=js"
export * from "./AccountType.vue?vue&type=script&lang=js"
import style0 from "./AccountType.vue?vue&type=style&index=0&id=06823898&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports